import { render, staticRenderFns } from "./ClickableImage.vue?vue&type=template&id=5452aa0d&scoped=true"
import script from "./ClickableImage.vue?vue&type=script&lang=js"
export * from "./ClickableImage.vue?vue&type=script&lang=js"
import style0 from "./ClickableImage.vue?vue&type=style&index=0&id=5452aa0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5452aa0d",
  null
  
)

export default component.exports